export default __webpack_public_path__ + "static/media/Horizontal 109.8c2f03da.svg";